<template>
  <div>
    <b-modal
      ref="modal-division"
      centered
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
    >
      <template #modal-header="">
        <h5>FILE OF DIVISIONS</h5>
        <b-button
          @click="adddivision()"
          class="btnAdd"
          size="sm"
          variant="dark"
        >
          <!-- <strong>NEW</strong> -->
          New
        </b-button>
      </template>

      <b-table
        hover
        striped
        select-mode="single"
        small
        sticky-header
        :items="items"
        :fields="fields"
        :busy="isBusy"
        head-variant="dark"
        class="mt-3"
        bordered
        style="max-height: 500px"
        ref="selectableTable"
        selectable
      >
        <template #cell(delete)="row">
          <b-button
            variant="outline-danger"
            @click="promptDelete(row.item, row.index)"
          >
            <b-icon icon="trash"></b-icon>
          </b-button>
        </template>

        <template #cell(edit)="row">
          <b-button @click="editdivision(row.item)" variant="outline-success">
            <b-icon icon="pencil"></b-icon>
          </b-button>
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>

      <template #modal-footer="{}">
        <div class="w-100">
          <p class="float-left">
            <strong> Count: {{ count }}</strong>
          </p>
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button
            class="float-right"
            size="sm"
            variant="secondary"
            @click="goHome()"
          >
            go Back
          </b-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-model="modalEditShow"
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
      centered
    >
      <template #modal-header="">
        <h5>Edit division</h5>
      </template>
      <b-card bg-variant="light">
        <b-form-group label-cols-lg="1" class="mb-0">
          <b-form-group
            label="Name:"
            label-for="name"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="name"
              v-model="actualdivision.nombre"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Address"
            label-for="address"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="address"
              v-model="actualdivision.direccion"
            ></b-form-input>
          </b-form-group>
        </b-form-group>
      </b-card>
      <template #modal-footer="{}">
        <div class="w-100">
          <b-button
            class="float-left"
            size="sm"
            variant="secondary"
            @click="modalEditShow = !modalEditShow"
          >
            go Back
          </b-button>
          <b-button
            class="float-right"
            size="sm"
            variant="success"
            @click="showMsgSave()"
          >
            Save
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      v-model="modalAddShow"
      no-close-on-backdrop
      header-bg-variant="light"
      footer-bg-variant="light"
      size="lg"
      button-size="sm"
      centered
    >
      <template #modal-header="">
        <h5>Add New division</h5>
      </template>
      <b-card bg-variant="light">
        <b-form-group label-cols-lg="1" class="mb-0">
          <b-form-group
            label="Name:"
            label-for="name"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input id="name" v-model="newdivision.nombre"></b-form-input>
          </b-form-group>

          <b-form-group
            label="Address"
            label-for="address"
            label-cols-sm="2"
            label-align-sm="right"
          >
            <b-form-input
              id="address"
              v-model="newdivision.direccion"
            ></b-form-input>
          </b-form-group>
        </b-form-group>
      </b-card>
      <template #modal-footer="{}">
        <div class="w-100">
          <b-button
            class="float-left"
            size="sm"
            variant="secondary"
            @click="modalAddShow = !modalAddShow"
          >
            go Back
          </b-button>
          <b-button
            class="float-right"
            size="sm"
            variant="success"
            @click="insertDivision()"
          >
            Save
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Divisions",
  data: function () {
    return {
      urlD: "https://www.imandrades.com/apiIMA/divisiones.php?action=",
      isBusy: false,
      fields: [
        { key: "nombre", label: "Division", class: "text-left" },
        { key: "delete", class: "text-center" },
        { key: "edit", class: "text-center" },
      ],
      modalEditShow: false,
      modalAddShow: false,
      items: [],
      divisiones: [],
      actualdivision: {},
      newdivision: {},
      count: 0,
      selected: [],
      confirmDelete: "",
      currentDivision: "GEORGIA",
      categorySelected: "0",
    };
  },
  mounted() {
    this.$refs["modal-division"].show();
    this.leerDivisiones();
  },
  methods: {
    leerDivisiones: async function () {
      try {
        let respuesta = await axios.get(this.urlD + "getDivisiones");
        this.divisiones = respuesta.data.divisiones;
        this.items = this.divisiones;
        this.count = this.items.length - 1;
      } catch (error) {
        console.log("Error Leyendo Divisiones");
      }
    },

    goHome() {
      this.$refs["modal-division"].hide();
      this.$router.push("menuDesktop");
    },
    /* onRowSelected() {
      this.selected = items;
      console.log(this.selected);
    }, */
    promptDelete(item, index) {
      console.log("ITEM:", item);
      console.log("INDEX:", index);
      this.confirmDelete = "";
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete division '" +
            item.nombre +
            "'",
          {
            title: "Delete division",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          this.confirmDelete = value;
          if (this.confirmDelete) {
            this.deleteDivision(item, index);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    editdivision(item) {
      this.actualdivision = item;
      this.modalEditShow = true;
    },
    adddivision() {
      this.newdivision = {};
      this.modalAddShow = true;
    },
    deleteDivision: async function (item, index) {
      try {
        console.log("ID: ", item.id_division);
        let respuesta = await axios.get(this.urlD, {
          params: {
            action: "deleteDivision",
            id: item.id_division,
          },
        });
        if (respuesta.data.deleted) {
          this.$bvModal
            .msgBoxOk("Action completed")
            .then((value) => {
              this.boxOk = value;
              if (this.boxOk) {
                this.items.splice(index, 1);
                this.count = this.items.length;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (error) {
        console.log("Error Reading Colors");
      }
    },

    insertDivision: async function () {
      let param = {
        nombre: this.newdivision.nombre,
        direccion: this.newdivision.direccion,
      };
      let paramSave = this.toFormData(param);
      try {
        let respuesta = await axios.post(
          this.urlD + "insertDivision",
          paramSave
        );
        if (respuesta.data.saved) {
          this.$bvModal
            .msgBoxOk("Action completed")
            .then((value) => {
              this.boxOk = value;
              if (this.boxOk) {
                this.items.push(param);
                this.modalAddShow = false;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (error) {
        console.log("Error Reading Colors");
      }
    },

    showMsgSave() {
      this.boxTwo = "";
      this.modalEditShow = false;
      this.modalAddShow = false;
      this.$bvModal
        .msgBoxOk("Data was submitted successfully", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then(() => {})
        .catch(() => {});
    },
    toFormData(obj) {
      let fd = new FormData();
      for (var i in obj) {
        fd.append(i, obj[i]);
      }
      return fd;
    },
  },
};
</script>


<style scoped>
.btnAdd {
  display: block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.btnAdd:hover {
  transform: scale(1.2);
}
</style>

